import { Button } from '@/components';
import CommonBlok from '@/components/common-blok';
import NewsItem from '@/modules/news/news-item';
import React from 'react';
import { MediaLogoList, NEWS_LIST } from '../../constants';
import * as styles from './index.module.less';
import { PublicArrowRightTail } from 'notta-web-icon';

const MediaPublic = () => {
  return (
    <CommonBlok isNewLayout title="メディア掲載実績・新着情報" className={styles.media_public_blok}>
      <div className={styles.wrapper}>
        <div className={styles.logo_container}>
          {MediaLogoList.map((item) => {
            return (
              <div key={item.src} className={styles.logo_item}>
                <img src={item.src} alt={item.alt} />
              </div>
            );
          })}
        </div>
        <div className={styles.news_list}>
          {NEWS_LIST.map((item) => {
            return <NewsItem data={item} key={item.link} />;
          })}
        </div>
        <div className={styles.btn_container}>
          <a href="/news">
            <Button type="link">
              もっと見る <PublicArrowRightTail />
            </Button>
          </a>
        </div>
      </div>
    </CommonBlok>
  );
};
export default MediaPublic;
